<template>
	<BaseLayout background-color-class="bg-color-white" :content-full-height="true" :footer-full="true">
		<div class="container">
			<div class="grid-md gutters-300-md">
				<div class="col-8-md col-offset-2-md">
					<BasePlaceHolderInline width="4em" :placehold="loading">
						<HelpCenterHeader
							v-if="section"
							:category="section.sectionCategory"
							:section="section"
							class="mb-50"
						/>
					</BasePlaceHolderInline>
					<BasePlaceHolder :class="{ 'mt-200': loading }" :line-count="5" :placehold="loading">
						<div v-if="section">
							<h1 class="heading-2">{{ section.name }}</h1>
							<p class="delta-md">{{ section.description }}</p>
							<HelpCenterList :section="section" />
						</div>
					</BasePlaceHolder>
				</div>
			</div>
		</div>
	</BaseLayout>
</template>

<script setup lang="ts">
import { computed, Ref, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getHelpCenterSection } from '@api/help-center';
import HelpCenterHeader from '@components/help-center/help-center-header.vue';
import HelpCenterList from '@components/help-center/help-center-list.vue';
import { HelpCenterSection } from 'types/help-center';
import { useHead } from '@unhead/vue';
import { useMixpanel } from '@utils/composables/use-mixpanel';

const loading = ref(true);

const section: Ref<HelpCenterSection | null> = ref(null);

const route = useRoute();
const router = useRouter();

const sectionId = computed((): string => route.params.sectionId as string);

const { trackMixpanelView } = useMixpanel();
async function setup(): Promise<void> {
	useHead({
		title: 'Help Center',
		meta: [{ property: 'og:title', content: 'Help Center' }]
	});
	try {
		section.value = await getHelpCenterSection(sectionId.value);
		loading.value = false;

		trackMixpanelView('Page', { 'View Title': section.value.name });
	} catch {
		await router.push({ name: 'help-center-landing' });
	}
}
setup();
</script>
